import { EyeSlash } from '@phosphor-icons/react';

export default EyeSlash;
